export const basicConfig = {
  gridFitApi: process.env.REACT_APP_GRIDFIT_API_HOST,
};
